import { FC } from 'react';

import { Box } from '@mui/system';

import HistoryStatus from '../types/historyStatus.enum';

type StatusIndicatorProps = {
  status: string;
};

const StatusIndicator: FC<StatusIndicatorProps> = ({ status }) => {
  return (
    <Box
      sx={{
        width: 15,
        height: 15,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'grey.300',
        borderRadius: '50%',
      }}
    >
      <Box
        sx={{
          width: 9,
          height: 9,
          borderRadius: '50%',
          ...(status === (HistoryStatus.CREATED as string) && {
            backgroundColor: 'primary.main',
          }),
          ...(status === (HistoryStatus.SCHEDULED as string) && {
            backgroundColor: 'success.main',
          }),
          ...(status === (HistoryStatus.HELD as string) && {
            backgroundColor: 'error.main',
          }),
          ...(status === (HistoryStatus.PENDING as string) && {
            backgroundColor: 'grey.600',
          }),
        }}
      />
    </Box>
  );
};

export default StatusIndicator;
